import { render } from "./thirdBox.vue?vue&type=template&id=30f9c824"
import script from "./thirdBox.vue?vue&type=script&lang=js"
export * from "./thirdBox.vue?vue&type=script&lang=js"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__